import { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { fetchMicrosite, trackEvent } from "@/api/client";
import Landing from "@/pages/Landing";
import CampaignStory from "@/pages/CampaignStory";

// Router for /:slug. Chooses the rendering engine per campaign:
//  - ready story sections  -> new Scroll Story engine (CampaignStory)
//  - configured, no story  -> legacy Landing with dynamic CTAs
//  - not found / error      -> the locked default homepage experience
export default function Microsite() {
  const { slug } = useParams();
  const [params] = useSearchParams();
  const [state, setState] = useState({ loading: true, campaign: null });

  useEffect(() => {
    let alive = true;
    fetchMicrosite(slug)
      .then((c) => {
        if (!alive) return;
        setState({ loading: false, campaign: c });
        // A QR scan is also a visit; count scans separately when the QR marker
        // is present (?s=qr, encoded into every generated Campaign Kit QR).
        if (params.get("s") === "qr") trackEvent(slug, "qr_scan");
      })
      .catch(() => alive && setState({ loading: false, campaign: null }));
    return () => {
      alive = false;
    };
  }, [slug, params]);

  if (state.loading) {
    return (
      <div className="grid min-h-screen place-items-center bg-[#070b18] text-3xl text-amber-300">
        ✦
      </div>
    );
  }
  if (!state.campaign) return <Landing />;
  if ((state.campaign.story_sections || []).length > 0) {
    return <CampaignStory campaign={state.campaign} />;
  }
  return <Landing presetCampaign={state.campaign} />;
}
